import Link from "next/link";
import type { TrailItem } from "@/lib/seo/product-breadcrumb";

/**
 * Visible product breadcrumb — the same `trail` array the BreadcrumbList
 * JSON-LD is built from (page.tsx), so the two never disagree, minus its last
 * item: the product itself, which the H1 right below already shows. The
 * JSON-LD keeps the product as its final item (Google's format). Paths are
 * locale-prefixed already. Nothing to show when only Home would be left.
 */
export default function ProductBreadcrumbs({
  items,
  label,
  className,
}: {
  items: readonly TrailItem[];
  label: string;
  className?: string;
}) {
  const visible = items.slice(0, -1);
  if (visible.length < 2) return null;
  return (
    <nav aria-label={label} className={className}>
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[13px] leading-5 text-gray-500">
        {visible.map((item, index) => (
          <li key={item.path} className="flex min-w-0 items-center gap-1.5">
            {index > 0 && (
              <span aria-hidden="true" className="text-gray-300">
                ›
              </span>
            )}
            <Link href={item.path} className="text-gray-600 hover:text-gray-900 hover:underline underline-offset-2">
              {item.name}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  );
}
